import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";

import LabeledContent from "../LabeledContent";
import { useTaxiServiceDefault } from "../../../../../../hooks";

const TaxiService = memo(() => {
	const { t } = useTranslation();
	const { company, taxiService } = useTaxiServiceDefault();

	const content = useMemo(
		() => (company && taxiService ? `${company}, ${taxiService}` : "-"),
		[company, taxiService],
	);

	return (
		<LabeledContent width={180} label={t("main_header.taxiService")}>
			{content}
		</LabeledContent>
	);
});

export default TaxiService;
